const locationBlueSVG = `
<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="28.337px" height="33.764px" viewBox="0 0 28.337 33.764" enable-background="new 0 0 28.337 33.764" xml:space="preserve">
<g id="Layer_1">
	<g>
		<g>
			<g>
				<g>
					<path d="M3.854,23.873l9.599,9.598c0.196,0.195,0.456,0.293,0.717,0.293c0.259,0,0.519-0.098,0.714-0.293
						l9.618-9.621c1.091-1.163,1.971-2.484,2.61-3.922c0.813-1.814,1.226-3.754,1.226-5.762C28.337,6.352,21.983,0,14.169,0
						C6.354,0,0,6.352,0,14.166c0,2.008,0.412,3.947,1.223,5.76C1.861,21.365,2.744,22.687,3.854,23.873z M14.169,2.02
						c6.696,0,12.146,5.446,12.146,12.144c0,1.721-0.354,3.383-1.052,4.939c-0.549,1.233-1.303,2.362-2.214,3.34l-8.881,8.882
						l-8.857-8.855c-0.937-1.001-1.69-2.133-2.238-3.373c-0.696-1.55-1.052-3.207-1.052-4.93C2.021,7.466,7.472,2.02,14.169,2.02z"
						/>
				</g>
			</g>
			<g>
				<g>
					<path d="M14.169,20.236c3.349,0,6.073-2.727,6.073-6.073c0-3.348-2.725-6.072-6.073-6.072
						c-3.351,0-6.074,2.725-6.074,6.075C8.095,17.518,10.818,20.236,14.169,20.236z M14.169,10.118c2.232,0,4.046,1.813,4.046,4.048
						c0,2.236-1.813,4.047-4.046,4.047c-2.235,0-4.05-1.811-4.05-4.047C10.119,11.931,11.939,10.118,14.169,10.118z"/>
				</g>
			</g>
		</g>
	</g>
</g>
<g id="LiveTXT" display="none">
</g>
<g id="GRids" display="none">
</g>
</svg>

`;

export default locationBlueSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/locationBlueSVG.js